export const SELF_REPORTED_CREDIT_LOOKUP = {
    EXCELLENT: 'R_720_850',
    GOOD: 'R_660_719',
    AVERAGE: 'R_620_659',
    POOR: 'R_580_619',
    BAD: 'R_300_579',
};

export const SELF_REPORTED_CREDIT = {
    [SELF_REPORTED_CREDIT_LOOKUP.EXCELLENT]: '720 & above',
    [SELF_REPORTED_CREDIT_LOOKUP.GOOD]: '660 - 719',
    [SELF_REPORTED_CREDIT_LOOKUP.AVERAGE]: '620 - 659',
    [SELF_REPORTED_CREDIT_LOOKUP.POOR]: '580 - 619',
    [SELF_REPORTED_CREDIT_LOOKUP.BAD]: '579 or below',
};

export const SELF_REPORTED_CREDIT_OPTIONS_VALUES = {
    [SELF_REPORTED_CREDIT_LOOKUP.EXCELLENT]: { creditScoreLow: 720, creditScoreHigh: 850 },
    [SELF_REPORTED_CREDIT_LOOKUP.GOOD]: { creditScoreLow: 660, creditScoreHigh: 719 },
    [SELF_REPORTED_CREDIT_LOOKUP.AVERAGE]: { creditScoreLow: 620, creditScoreHigh: 659 },
    [SELF_REPORTED_CREDIT_LOOKUP.POOR]: { creditScoreLow: 580, creditScoreHigh: 619 },
    [SELF_REPORTED_CREDIT_LOOKUP.BAD]: { creditScoreLow: 300, creditScoreHigh: 579 },
};
